




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import WordFade from '@/common/vue/WordFade.vue';
import IntersectionDirective from '@/common/vue/intersection-directive';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const HeaderFlyoutImageItemProps = Vue.extend({
  props: {
    linkUrl: String,
    linkTarget: String,
    imageAlt: String,
    imageSrc: String,
    imageSrcset: String,
    mainTitle: String,
    metaTitle: String,
    largeItem: Boolean,
    controlledBySelf: Boolean, // true if intersection should trigger fade in/out. True for search, false for header flyout
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
  components: {
    WordFade,
  },
})
export default class HeaderFlyoutImageItem extends HeaderFlyoutImageItemProps {
  mouseEnter = false;
  isIntersecting = false;
  observerOptions = {
    rootMargin: '0px 0px -5% 0px',
  }

  handleIntersection (isIntersecting: boolean, el: HTMLElement) {
    const { top } = el.getBoundingClientRect();
    // if the content scrolls out of view within the viewport (mobile flyout)
    if (isIntersecting || top <= (window.innerHeight / 2)) {
      this.isIntersecting = true;
    } else if (!isIntersecting) {
      this.isIntersecting = false;
    }
  }

  handleMouseEnter (): void {
    this.mouseEnter = true;
  }

  handleMouseLeave (): void {
    this.mouseEnter = false;
  }

  @Watch('mouseEnter')
  handleMouseChange (): void {
    if (this.$el) {
      const event = new CustomEvent('flyout-item-hover', {
        bubbles: true,
        composed: true,
        detail: {
          mouseEnter: this.mouseEnter,
        },
      });
      this.$el.dispatchEvent(event);
    }
  }

  get rootClass () {
    return {
      'brandhub-header-flyout-image-item--large-item': this.largeItem,
      'brandhub-header-flyout-image-item--regular-item': !this.largeItem,
      'brandhub-header-flyout-image-item--intersecting': this.isIntersecting,
      'brandhub-header-flyout-image-item--controlled-by-self': this.controlledBySelf,
    };
  }

  get textAlign () {
    return this.largeItem ? 'always-center' : 'desktop-center';
  }

  onClick () {
    if (this.mainTitle) {
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Header Flyout', this.mainTitle, this.linkUrl);
    }
  }
}
